// This file is auto-generated by @hey-api/openapi-ts

import {
	type Client,
	type ClientMeta,
	formDataBodySerializer,
	type Options as Options2,
	type RequestResult,
	type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
	ApplyWorkflowDraftData,
	ApplyWorkflowDraftResponses,
	ApproveCapInstanceSignOffSetData,
	ApproveCapInstanceSignOffSetResponses,
	AssignResponsiblesToPurchaseOrdersData,
	AssignResponsiblesToPurchaseOrdersResponses,
	CalculateReimbursementAmountData,
	CalculateReimbursementAmountResponses,
	CheckProductionChecklistItemData,
	CheckProductionChecklistItemResponses,
	ClearAllCachesData,
	ClearAllCachesResponses,
	CloseClientTaskProviderAssignmentReportingPeriodData,
	CloseClientTaskProviderAssignmentReportingPeriodResponses,
	ConfirmClientTaskProviderAssignmentReportingPeriodManualReviewData,
	ConfirmClientTaskProviderAssignmentReportingPeriodManualReviewResponses,
	ConfirmClientTaskProviderAssignmentReportingPeriodReviewData,
	ConfirmClientTaskProviderAssignmentReportingPeriodReviewResponses,
	CreateActivityData,
	CreateActivityResponses,
	CreateAgencyAddressData,
	CreateAgencyAddressResponses,
	CreateAgencyData,
	CreateAgencyFrameworkAgreementData,
	CreateAgencyFrameworkAgreementResponses,
	CreateAgencyMemberData,
	CreateAgencyMemberResponses,
	CreateAgencyResponses,
	CreateBusinessCentralTeamCodeData,
	CreateBusinessCentralTeamCodeResponses,
	CreateCapDefinitionData,
	CreateCapDefinitionResponses,
	CreateCapInstanceSignOffSetData,
	CreateCapInstanceSignOffSetResponses,
	CreateClientAddressData,
	CreateClientAddressResponses,
	CreateClientContactData,
	CreateClientContactResponses,
	CreateClientData,
	CreateClientFrameworkAgreementData,
	CreateClientFrameworkAgreementResponses,
	CreateClientLegalEntitySettingsData,
	CreateClientLegalEntitySettingsResponses,
	CreateClientResponses,
	CreateConsultantAddressData,
	CreateConsultantAddressResponses,
	CreateConsultantData,
	CreateConsultantFrameworkAgreementData,
	CreateConsultantFrameworkAgreementResponses,
	CreateConsultantResponses,
	CreateDaysOffData,
	CreateDaysOffResponses,
	CreateFullCreditNoteData,
	CreateFullCreditNoteResponses,
	CreateIntercompanyFrameworkAgreementData,
	CreateIntercompanyFrameworkAgreementResponses,
	CreateInvoiceDatesRulesetData,
	CreateInvoiceDatesRulesetResponses,
	CreateInvoiceDraftData,
	CreateInvoiceDraftForExpectedInvoiceData,
	CreateInvoiceDraftForExpectedInvoiceResponses,
	CreateInvoiceDraftResponses,
	CreateInvoiceRowsLayoutData,
	CreateInvoiceRowsLayoutResponses,
	CreateInvoicingScheduleCustomDatesData,
	CreateInvoicingScheduleCustomDatesResponses,
	CreatePaymentTermsData,
	CreatePaymentTermsResponses,
	CreateProductionChecklistItemData,
	CreateProductionChecklistItemResponses,
	CreateProviderCapInstanceSignOffSetData,
	CreateProviderCapInstanceSignOffSetResponses,
	CreatePurchaseOrderData,
	CreatePurchaseOrderResponses,
	CreateScheduleData,
	CreateScheduleResponses,
	CreateSelfBillingNumberSequencesData,
	CreateSelfBillingNumberSequencesResponses,
	CreateUnitOfMeasurementConversionTableData,
	CreateUnitOfMeasurementConversionTableResponses,
	CreateUnitOfMeasurementData,
	CreateUnitOfMeasurementResponses,
	CreateVatCodeData,
	CreateVatCodeResponses,
	CreateWorkflowData,
	CreateWorkflowDraftData,
	CreateWorkflowDraftResponses,
	CreateWorkflowResponses,
	DecideExpenseRfcsData,
	DecideExpenseRfcsResponses,
	DecideTimesheetDailyReportRfcsData,
	DecideTimesheetDailyReportRfcsResponses,
	DeleteCapDefinitionData,
	DeleteCapDefinitionResponses,
	DeleteCapInstanceSignOffSetData,
	DeleteCapInstanceSignOffSetResponses,
	DeleteDaysOffData,
	DeleteDaysOffResponses,
	DeleteProviderCapInstanceSignOffSetData,
	DeleteProviderCapInstanceSignOffSetResponses,
	DeleteWorkflowData,
	DeleteWorkflowResponses,
	GetActiveCapDefinitionsData,
	GetActiveCapDefinitionsResponses,
	GetActivitiesData,
	GetActivitiesResponses,
	GetAgenciesData,
	GetAgenciesResponses,
	GetAgencyAddressDetailsData,
	GetAgencyAddressDetailsResponses,
	GetAgencyAddressesData,
	GetAgencyAddressesResponses,
	GetAgencyDetailsData,
	GetAgencyDetailsResponses,
	GetAgencyFrameworkAgreementDetailsData,
	GetAgencyFrameworkAgreementDetailsResponses,
	GetAgencyFrameworkAgreementsData,
	GetAgencyFrameworkAgreementsResponses,
	GetAgencyMemberDetailsData,
	GetAgencyMemberDetailsResponses,
	GetAgencyMembersData,
	GetAgencyMembersResponses,
	GetAllPurchaseOrderBillableAllocationsData,
	GetAllPurchaseOrderBillableAllocationsResponses,
	GetBillableDetailsData,
	GetBillableDetailsResponses,
	GetBillableDistributionDetailsData,
	GetBillableDistributionDetailsResponses,
	GetBillableExpectedInvoiceDistributionDetailsData,
	GetBillableExpectedInvoiceDistributionDetailsResponses,
	GetBillablesData,
	GetBillablesResponses,
	GetBreachedCapInstancesData,
	GetBreachedCapInstancesResponses,
	GetBusinessCentralTeamCodesData,
	GetBusinessCentralTeamCodesResponses,
	GetBusinessEntitiesData,
	GetBusinessEntitiesResponses,
	GetBusinessEntityAddressesData,
	GetBusinessEntityAddressesResponses,
	GetBusinessEntityContactsData,
	GetBusinessEntityContactsResponses,
	GetBusinessEntityDetailsData,
	GetBusinessEntityDetailsResponses,
	GetCapDefinitionDetailsData,
	GetCapDefinitionDetailsResponses,
	GetCapDefinitionsData,
	GetCapDefinitionsResponses,
	GetCapInstanceSignOffSetDetailsData,
	GetCapInstanceSignOffSetDetailsResponses,
	GetCapInstanceSignOffSetFileData,
	GetCapInstanceSignOffSetFileResponses,
	GetCapInstanceSignOffSetsData,
	GetCapInstanceSignOffSetsDetailsData,
	GetCapInstanceSignOffSetsDetailsResponses,
	GetCapInstanceSignOffSetsResponses,
	GetClientAddressDetailsData,
	GetClientAddressDetailsResponses,
	GetClientAddressesData,
	GetClientAddressesResponses,
	GetClientContactDetailsData,
	GetClientContactDetailsResponses,
	GetClientContactsData,
	GetClientContactsResponses,
	GetClientDetailsData,
	GetClientDetailsResponses,
	GetClientFrameworkAgreementDetailsData,
	GetClientFrameworkAgreementDetailsResponses,
	GetClientFrameworkAgreementsData,
	GetClientFrameworkAgreementsResponses,
	GetClientLegalEntitySettingsData,
	GetClientLegalEntitySettingsResponses,
	GetClientsAndDatesData,
	GetClientsAndDatesResponses,
	GetClientsData,
	GetClientsResponses,
	GetClientTasksAndExpenseActivitiesData,
	GetClientTasksAndExpenseActivitiesResponses,
	GetConsultantAddressDetailsData,
	GetConsultantAddressDetailsResponses,
	GetConsultantAddressesData,
	GetConsultantAddressesResponses,
	GetConsultantDetailsData,
	GetConsultantDetailsResponses,
	GetConsultantFrameworkAgreementDetailsData,
	GetConsultantFrameworkAgreementDetailsResponses,
	GetConsultantFrameworkAgreementsData,
	GetConsultantFrameworkAgreementsResponses,
	GetConsultantsData,
	GetConsultantsResponses,
	GetConvertibleCurrenciesData,
	GetConvertibleCurrenciesResponses,
	GetCountriesData,
	GetCountriesResponses,
	GetCurrenciesData,
	GetCurrenciesResponses,
	GetDaysOffData,
	GetDaysOffDetailsData,
	GetDaysOffDetailsResponses,
	GetDaysOffResponses,
	GetDocumentCaptureInvoiceData,
	GetDocumentCaptureInvoiceFileData,
	GetDocumentCaptureInvoiceFileResponses,
	GetDocumentCaptureInvoiceResponses,
	GetDocumentCaptureInvoicesData,
	GetDocumentCaptureInvoicesResponses,
	GetEmployeesData,
	GetEmployeesResponses,
	GetExpectedInvoiceBillableAllocationsData,
	GetExpectedInvoiceBillableAllocationsResponses,
	GetExpectedInvoiceBillableLinesData,
	GetExpectedInvoiceBillableLinesResponses,
	GetExpectedInvoiceDetailsData,
	GetExpectedInvoiceDetailsResponses,
	GetExpectedInvoiceGroupsData,
	GetExpectedInvoiceGroupsForWorkflowData,
	GetExpectedInvoiceGroupsForWorkflowResponses,
	GetExpectedInvoiceGroupsResponses,
	GetExpectedInvoicesData,
	GetExpectedInvoicesForBillablesData,
	GetExpectedInvoicesForBillablesResponses,
	GetExpectedInvoicesResponses,
	GetExpenseDetailsData,
	GetExpenseDetailsResponses,
	GetExpenseReceiptFileData,
	GetExpenseReceiptFileResponses,
	GetExpensesData,
	GetExpensesResponses,
	GetIntercompanyFrameworkAgreementDetailsData,
	GetIntercompanyFrameworkAgreementDetailsResponses,
	GetIntercompanyFrameworkAgreementsData,
	GetIntercompanyFrameworkAgreementsResponses,
	GetInternalLegalEntitiesData,
	GetInternalLegalEntitiesResponses,
	GetInternalLegalEntityAddressesData,
	GetInternalLegalEntityAddressesResponses,
	GetInternalLegalEntityDetailsData,
	GetInternalLegalEntityDetailsResponses,
	GetInternalLegalEntityInvoiceSendingProfilesData,
	GetInternalLegalEntityInvoiceSendingProfilesResponses,
	GetInternalLegalEntityInvoicingDefaultsData,
	GetInternalLegalEntityInvoicingDefaultsResponses,
	GetInvoiceAttachmentFileData,
	GetInvoiceAttachmentFileResponses,
	GetInvoiceAutoRowsData,
	GetInvoiceAutoRowsResponses,
	GetInvoiceDatesRulesetDetailsData,
	GetInvoiceDatesRulesetDetailsResponses,
	GetInvoiceDatesRulesetsData,
	GetInvoiceDatesRulesetsResponses,
	GetInvoiceDetailsData,
	GetInvoiceDetailsMismatchData,
	GetInvoiceDetailsMismatchResponses,
	GetInvoiceDetailsResponses,
	GetInvoiceReceiptsData,
	GetInvoiceReceiptsResponses,
	GetInvoiceRowsLayoutDetailsData,
	GetInvoiceRowsLayoutDetailsResponses,
	GetInvoiceRowsLayoutsData,
	GetInvoiceRowsLayoutsResponses,
	GetInvoicesData,
	GetInvoicesResponses,
	GetInvoiceTimesheetData,
	GetInvoiceTimesheetPdfData,
	GetInvoiceTimesheetPdfResponses,
	GetInvoiceTimesheetResponses,
	GetInvoicingScheduleCustomDatesDetailsData,
	GetInvoicingScheduleCustomDatesDetailsResponses,
	GetInvoicingScheduleCustomDatesListData,
	GetInvoicingScheduleCustomDatesListResponses,
	GetLanguagesData,
	GetLanguagesResponses,
	GetMonetaryCapInstanceAllocationsData,
	GetMonetaryCapInstanceAllocationsResponses,
	GetMonetaryCapInstanceDetailsData,
	GetMonetaryCapInstanceDetailsResponses,
	GetMonetaryCapInstancesData,
	GetMonetaryCapInstancesResponses,
	GetPaymentTermsData,
	GetPaymentTermsDetailsData,
	GetPaymentTermsDetailsResponses,
	GetPaymentTermsResponses,
	GetPendingCapInstanceSignOffSetsData,
	GetPendingCapInstanceSignOffSetsResponses,
	GetProductionChecklistItemsData,
	GetProductionChecklistItemsResponses,
	GetProductionProviderReportingPeriodsData,
	GetProductionProviderReportingPeriodsResponses,
	GetProfessionalRolesData,
	GetProfessionalRolesResponses,
	GetProviderCapInstanceSignOffSetFileData,
	GetProviderCapInstanceSignOffSetFileResponses,
	GetProviderReportingPeriodDetailsData,
	GetProviderReportingPeriodDetailsResponses,
	GetProviderReportingPeriodsData,
	GetProviderReportingPeriodsResponses,
	GetPurchaseOrderDetailsData,
	GetPurchaseOrderDetailsResponses,
	GetPurchaseOrderEmployeeResponsiblesData,
	GetPurchaseOrderEmployeeResponsiblesResponses,
	GetPurchaseOrderFileData,
	GetPurchaseOrderFileResponses,
	GetPurchaseOrderIssuerResponsiblesData,
	GetPurchaseOrderIssuerResponsiblesResponses,
	GetPurchaseOrderResponsiblesDefaultsData,
	GetPurchaseOrderResponsiblesDefaultsResponses,
	GetPurchaseOrdersData,
	GetPurchaseOrdersResponses,
	GetResolvedCapInstanceSignOffSetsData,
	GetResolvedCapInstanceSignOffSetsResponses,
	GetResponsiblesData,
	GetResponsiblesResponses,
	GetSagaDetailsData,
	GetSagaDetailsResponses,
	GetSagasData,
	GetSagasResponses,
	GetSagaStepTimingsData,
	GetSagaStepTimingsResponses,
	GetScheduleDetailsData,
	GetScheduleDetailsResponses,
	GetSchedulePeriodsData,
	GetSchedulePeriodsResponses,
	GetSchedulesData,
	GetSchedulesResponses,
	GetSkiDiscountHistoricalValuesData,
	GetSkiDiscountHistoricalValuesResponses,
	GetTeamsAndDivisionsTreeData,
	GetTeamsAndDivisionsTreeResponses,
	GetTenantDetailsData,
	GetTenantDetailsResponses,
	GetTenantsData,
	GetTenantsResponses,
	GetTimesheetDailyFormsData,
	GetTimesheetDailyFormsResponses,
	GetTimesheetDailyReportsData,
	GetTimesheetDailyReportsDetailsData,
	GetTimesheetDailyReportsDetailsResponses,
	GetTimesheetDailyReportsResponses,
	GetUnitBatchesData,
	GetUnitBatchesResponses,
	GetUnitCapInstanceAllocationsData,
	GetUnitCapInstanceAllocationsResponses,
	GetUnitCapInstanceDetailsData,
	GetUnitCapInstanceDetailsResponses,
	GetUnitCapInstancesData,
	GetUnitCapInstancesResponses,
	GetUnitOfMeasurementConversionTableDetailsData,
	GetUnitOfMeasurementConversionTableDetailsResponses,
	GetUnitOfMeasurementConversionTablesData,
	GetUnitOfMeasurementConversionTablesResponses,
	GetUnitOfMeasurementDetailsData,
	GetUnitOfMeasurementDetailsResponses,
	GetUnitsOfMeasurementData,
	GetUnitsOfMeasurementResponses,
	GetUserManagementPermissionsModelData,
	GetUserManagementPermissionsModelResponses,
	GetVatCodeDetailsModelData,
	GetVatCodeDetailsModelResponses,
	GetVatCodesData,
	GetVatCodesResponses,
	GetWorkflowCapDefinitionAllocationSetDetailsData,
	GetWorkflowCapDefinitionAllocationSetDetailsResponses,
	GetWorkflowChangesetData,
	GetWorkflowChangesetResponses,
	GetWorkflowDetailsData,
	GetWorkflowDetailsResponses,
	GetWorkflowDraftChangesetData,
	GetWorkflowDraftChangesetResponses,
	GetWorkflowDraftDetailsData,
	GetWorkflowDraftDetailsResponses,
	GetWorkflowDraftsData,
	GetWorkflowDraftsResponses,
	GetWorkflowExpectedInvoiceGroupDistributionDetailsData,
	GetWorkflowExpectedInvoiceGroupDistributionDetailsResponses,
	GetWorkflowInputDetailsData,
	GetWorkflowInputDetailsResponses,
	GetWorkflowPurchaseOrderLimitAllocationSetDetailsData,
	GetWorkflowPurchaseOrderLimitAllocationSetDetailsResponses,
	GetWorkflowsData,
	GetWorkflowSourcingRequestDetailsData,
	GetWorkflowSourcingRequestDetailsResponses,
	GetWorkflowsResponses,
	GetWorkflowsV2Data,
	GetWorkflowsV2Responses,
	IssueAgencyMemberSessionTokenData,
	IssueAgencyMemberSessionTokenResponses,
	IssueConsultantSessionTokenData,
	IssueConsultantSessionTokenResponses,
	MarkAsDraftData,
	MarkAsDraftResponses,
	MarkAsReadyToSendData,
	MarkAsReadyToSendResponses,
	PatchAgencyFrameworkAgreementData,
	PatchAgencyFrameworkAgreementResponses,
	PatchClientFrameworkAgreementData,
	PatchClientFrameworkAgreementResponses,
	PatchClientLegalEntitySettingsData,
	PatchClientLegalEntitySettingsResponses,
	PatchConsultantFrameworkAgreementData,
	PatchConsultantFrameworkAgreementResponses,
	PatchIntercompanyFrameworkAgreementData,
	PatchIntercompanyFrameworkAgreementResponses,
	PatchPurchaseOrderData,
	PatchPurchaseOrderResponses,
	PatchUnitOfMeasurementConversionTableData,
	PatchUnitOfMeasurementConversionTableResponses,
	PatchWorkflowDraftData,
	PatchWorkflowDraftResponses,
	PostApiFileUploadTempData,
	PostApiFileUploadTempResponses,
	ProcessBusinessCentralAcceptanceData,
	ProcessBusinessCentralAcceptanceResponses,
	ProcessBusinessCentralIssuanceData,
	ProcessBusinessCentralIssuanceResponses,
	ProcessBusinessCentralRejectionData,
	ProcessBusinessCentralRejectionResponses,
	PullInvoiceBusinessCentralStatusData,
	PullInvoiceBusinessCentralStatusResponses,
	RejectCapInstanceSignOffSetData,
	RejectCapInstanceSignOffSetResponses,
	RelinkToExpectedInvoiceData,
	RelinkToExpectedInvoiceResponses,
	SaveExpensesData,
	SaveExpensesResponses,
	SaveTimesheetDailyReportDraftsData,
	SaveTimesheetDailyReportDraftsResponses,
	SaveTimesheetDailyReportRfcsData,
	SaveTimesheetDailyReportRfcsResponses,
	ScheduleContinueSagaData,
	ScheduleContinueSagaResponses,
	SendToBusinessCentralData,
	SendToBusinessCentralResponses,
	SetPurchaseOrderLimitsCompletionData,
	SetPurchaseOrderLimitsCompletionResponses,
	SubmitTimesheetDailyReportsData,
	SubmitTimesheetDailyReportsResponses,
	SynchronizeUserManagementDataData,
	SynchronizeUserManagementDataResponses,
	UncheckProductionChecklistItemData,
	UncheckProductionChecklistItemResponses,
	UpdateAgencyAddressData,
	UpdateAgencyAddressResponses,
	UpdateAgencyData,
	UpdateAgencyFrameworkAgreementData,
	UpdateAgencyFrameworkAgreementResponses,
	UpdateAgencyMemberData,
	UpdateAgencyMemberResponses,
	UpdateAgencyResponses,
	UpdateCapDefinitionData,
	UpdateCapDefinitionResponses,
	UpdateCapInstanceSignOffSetData,
	UpdateCapInstanceSignOffSetResponses,
	UpdateClientAddressData,
	UpdateClientAddressResponses,
	UpdateClientContactData,
	UpdateClientContactResponses,
	UpdateClientData,
	UpdateClientFrameworkAgreementData,
	UpdateClientFrameworkAgreementResponses,
	UpdateClientResponses,
	UpdateConsultantAddressData,
	UpdateConsultantAddressResponses,
	UpdateConsultantData,
	UpdateConsultantFrameworkAgreementData,
	UpdateConsultantFrameworkAgreementResponses,
	UpdateConsultantResponses,
	UpdateDaysOffData,
	UpdateDaysOffResponses,
	UpdateIntercompanyFrameworkAgreementData,
	UpdateIntercompanyFrameworkAgreementResponses,
	UpdateInternalLegalEntityData,
	UpdateInternalLegalEntityResponses,
	UpdateInvoiceAllocationsData,
	UpdateInvoiceAllocationsResponses,
	UpdateInvoiceData,
	UpdateInvoiceResponses,
	UpdateInvoiceRowsLayoutData,
	UpdateInvoiceRowsLayoutResponses,
	UpdateInvoicingScheduleCustomDatesData,
	UpdateInvoicingScheduleCustomDatesResponses,
	UpdatePaymentTermsData,
	UpdatePaymentTermsResponses,
	UpdateProviderCapInstanceSignOffSetData,
	UpdateProviderCapInstanceSignOffSetResponses,
	UpdatePurchaseOrderLimitAllocationsData,
	UpdatePurchaseOrderLimitAllocationsResponses,
	UpdateTeamsAndDivisionsNodeData,
	UpdateTeamsAndDivisionsNodeResponses,
	UpdateTenantData,
	UpdateTenantResponses,
	UpdateUnitOfMeasurementConversionTableData,
	UpdateUnitOfMeasurementConversionTableResponses,
	UpdateUnitOfMeasurementData,
	UpdateUnitOfMeasurementResponses,
} from './types.gen';

export type Options<
	TData extends TDataShape = TDataShape,
	ThrowOnError extends boolean = boolean,
	TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getActivities = <ThrowOnError extends boolean = true>(
	options?: Options<GetActivitiesData, ThrowOnError>,
): RequestResult<GetActivitiesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetActivitiesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Activity',
		...options,
	});

export const createActivity = <ThrowOnError extends boolean = true>(
	options?: Options<CreateActivityData, ThrowOnError>,
): RequestResult<CreateActivityResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateActivityResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Activity',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getAgencies = <ThrowOnError extends boolean = true>(
	options?: Options<GetAgenciesData, ThrowOnError>,
): RequestResult<GetAgenciesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetAgenciesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Agency',
		...options,
	});

export const createAgency = <ThrowOnError extends boolean = true>(
	options?: Options<CreateAgencyData, ThrowOnError>,
): RequestResult<CreateAgencyResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateAgencyResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Agency',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateAgency = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateAgencyData, ThrowOnError>,
): RequestResult<UpdateAgencyResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateAgencyResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Agency',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getAgencyDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetAgencyDetailsData, ThrowOnError>,
): RequestResult<GetAgencyDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetAgencyDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Agency/{id}',
		...options,
	});

export const getAgencyAddresses = <ThrowOnError extends boolean = true>(
	options?: Options<GetAgencyAddressesData, ThrowOnError>,
): RequestResult<GetAgencyAddressesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetAgencyAddressesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyAddress',
		...options,
	});

export const createAgencyAddress = <ThrowOnError extends boolean = true>(
	options?: Options<CreateAgencyAddressData, ThrowOnError>,
): RequestResult<CreateAgencyAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateAgencyAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateAgencyAddress = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateAgencyAddressData, ThrowOnError>,
): RequestResult<UpdateAgencyAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateAgencyAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getAgencyAddressDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetAgencyAddressDetailsData, ThrowOnError>,
): RequestResult<GetAgencyAddressDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetAgencyAddressDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyAddress/{id}',
		...options,
	});

export const getAgencyFrameworkAgreements = <ThrowOnError extends boolean = true>(
	options?: Options<GetAgencyFrameworkAgreementsData, ThrowOnError>,
): RequestResult<GetAgencyFrameworkAgreementsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetAgencyFrameworkAgreementsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyFrameworkAgreement',
		...options,
	});

export const patchAgencyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<PatchAgencyFrameworkAgreementData, ThrowOnError>,
): RequestResult<PatchAgencyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchAgencyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createAgencyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<CreateAgencyFrameworkAgreementData, ThrowOnError>,
): RequestResult<CreateAgencyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateAgencyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateAgencyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateAgencyFrameworkAgreementData, ThrowOnError>,
): RequestResult<UpdateAgencyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateAgencyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getAgencyFrameworkAgreementDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetAgencyFrameworkAgreementDetailsData, ThrowOnError>,
): RequestResult<GetAgencyFrameworkAgreementDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetAgencyFrameworkAgreementDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyFrameworkAgreement/{id}',
		...options,
	});

export const getAgencyMembers = <ThrowOnError extends boolean = true>(
	options?: Options<GetAgencyMembersData, ThrowOnError>,
): RequestResult<GetAgencyMembersResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetAgencyMembersResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyMember',
		...options,
	});

export const createAgencyMember = <ThrowOnError extends boolean = true>(
	options?: Options<CreateAgencyMemberData, ThrowOnError>,
): RequestResult<CreateAgencyMemberResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateAgencyMemberResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyMember',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateAgencyMember = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateAgencyMemberData, ThrowOnError>,
): RequestResult<UpdateAgencyMemberResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateAgencyMemberResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyMember',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getAgencyMemberDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetAgencyMemberDetailsData, ThrowOnError>,
): RequestResult<GetAgencyMemberDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetAgencyMemberDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/AgencyMember/{id}',
		...options,
	});

export const getBillables = <ThrowOnError extends boolean = true>(
	options?: Options<GetBillablesData, ThrowOnError>,
): RequestResult<GetBillablesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBillablesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Billable',
		...options,
	});

export const getBillableDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetBillableDetailsData, ThrowOnError>,
): RequestResult<GetBillableDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetBillableDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Billable/{billableId}',
		...options,
	});

export const getBillableDistributionDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetBillableDistributionDetailsData, ThrowOnError>,
): RequestResult<GetBillableDistributionDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetBillableDistributionDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BillableDistribution/{billableId}',
		...options,
	});

export const getBillableExpectedInvoiceDistributionDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetBillableExpectedInvoiceDistributionDetailsData, ThrowOnError>,
): RequestResult<GetBillableExpectedInvoiceDistributionDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetBillableExpectedInvoiceDistributionDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BillableExpectedInvoiceDistribution/{billableId}',
		...options,
	});

export const getBusinessCentralTeamCodes = <ThrowOnError extends boolean = true>(
	options?: Options<GetBusinessCentralTeamCodesData, ThrowOnError>,
): RequestResult<GetBusinessCentralTeamCodesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBusinessCentralTeamCodesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessCentralTeamCode',
		...options,
	});

export const createBusinessCentralTeamCode = <ThrowOnError extends boolean = true>(
	options?: Options<CreateBusinessCentralTeamCodeData, ThrowOnError>,
): RequestResult<CreateBusinessCentralTeamCodeResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateBusinessCentralTeamCodeResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessCentralTeamCode',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getBusinessEntities = <ThrowOnError extends boolean = true>(
	options?: Options<GetBusinessEntitiesData, ThrowOnError>,
): RequestResult<GetBusinessEntitiesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBusinessEntitiesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessEntity',
		...options,
	});

export const getBusinessEntityDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetBusinessEntityDetailsData, ThrowOnError>,
): RequestResult<GetBusinessEntityDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetBusinessEntityDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessEntity/{id}',
		...options,
	});

export const getBusinessEntityAddresses = <ThrowOnError extends boolean = true>(
	options?: Options<GetBusinessEntityAddressesData, ThrowOnError>,
): RequestResult<GetBusinessEntityAddressesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBusinessEntityAddressesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessEntityAddress',
		...options,
	});

export const getBusinessEntityContacts = <ThrowOnError extends boolean = true>(
	options?: Options<GetBusinessEntityContactsData, ThrowOnError>,
): RequestResult<GetBusinessEntityContactsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBusinessEntityContactsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/BusinessEntityContact',
		...options,
	});

export const getCapDefinitions = <ThrowOnError extends boolean = true>(
	options?: Options<GetCapDefinitionsData, ThrowOnError>,
): RequestResult<GetCapDefinitionsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetCapDefinitionsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapDefinition',
		...options,
	});

export const createCapDefinition = <ThrowOnError extends boolean = true>(
	options?: Options<CreateCapDefinitionData, ThrowOnError>,
): RequestResult<CreateCapDefinitionResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateCapDefinitionResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapDefinition',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateCapDefinition = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateCapDefinitionData, ThrowOnError>,
): RequestResult<UpdateCapDefinitionResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateCapDefinitionResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapDefinition',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const deleteCapDefinition = <ThrowOnError extends boolean = true>(
	options: Options<DeleteCapDefinitionData, ThrowOnError>,
): RequestResult<DeleteCapDefinitionResponses, unknown, ThrowOnError> =>
	(options.client ?? client).delete<DeleteCapDefinitionResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapDefinition/{id}',
		...options,
	});

export const getCapDefinitionDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetCapDefinitionDetailsData, ThrowOnError>,
): RequestResult<GetCapDefinitionDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetCapDefinitionDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapDefinition/{id}',
		...options,
	});

export const getCapInstanceSignOffSets = <ThrowOnError extends boolean = true>(
	options?: Options<GetCapInstanceSignOffSetsData, ThrowOnError>,
): RequestResult<GetCapInstanceSignOffSetsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetCapInstanceSignOffSetsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet',
		...options,
	});

export const createCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<CreateCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<CreateCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<UpdateCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const approveCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<ApproveCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<ApproveCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ApproveCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet/approve',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const rejectCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<RejectCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<RejectCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<RejectCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet/reject',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const deleteCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options: Options<DeleteCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<DeleteCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options.client ?? client).delete<DeleteCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet/{id}',
		...options,
	});

export const getCapInstanceSignOffSetDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetCapInstanceSignOffSetDetailsData, ThrowOnError>,
): RequestResult<GetCapInstanceSignOffSetDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetCapInstanceSignOffSetDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet/{id}',
		...options,
	});

export const getCapInstanceSignOffSetFile = <ThrowOnError extends boolean = true>(
	options: Options<GetCapInstanceSignOffSetFileData, ThrowOnError>,
): RequestResult<GetCapInstanceSignOffSetFileResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetCapInstanceSignOffSetFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/CapInstanceSignOffSet/{id}/sign-off-file/{fileId}',
		...options,
	});

export const getClients = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientsData, ThrowOnError>,
): RequestResult<GetClientsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Client',
		...options,
	});

export const createClient = <ThrowOnError extends boolean = true>(
	options?: Options<CreateClientData, ThrowOnError>,
): RequestResult<CreateClientResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateClientResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Client',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateClient = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateClientData, ThrowOnError>,
): RequestResult<UpdateClientResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateClientResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Client',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetClientDetailsData, ThrowOnError>,
): RequestResult<GetClientDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetClientDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Client/{id}',
		...options,
	});

export const getClientAddresses = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientAddressesData, ThrowOnError>,
): RequestResult<GetClientAddressesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientAddressesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientAddress',
		...options,
	});

export const createClientAddress = <ThrowOnError extends boolean = true>(
	options?: Options<CreateClientAddressData, ThrowOnError>,
): RequestResult<CreateClientAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateClientAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateClientAddress = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateClientAddressData, ThrowOnError>,
): RequestResult<UpdateClientAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateClientAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientAddressDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetClientAddressDetailsData, ThrowOnError>,
): RequestResult<GetClientAddressDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetClientAddressDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientAddress/{id}',
		...options,
	});

export const getClientContacts = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientContactsData, ThrowOnError>,
): RequestResult<GetClientContactsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientContactsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientContact',
		...options,
	});

export const createClientContact = <ThrowOnError extends boolean = true>(
	options?: Options<CreateClientContactData, ThrowOnError>,
): RequestResult<CreateClientContactResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateClientContactResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientContact',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateClientContact = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateClientContactData, ThrowOnError>,
): RequestResult<UpdateClientContactResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateClientContactResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientContact',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientContactDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetClientContactDetailsData, ThrowOnError>,
): RequestResult<GetClientContactDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetClientContactDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientContact/{id}',
		...options,
	});

export const getClientFrameworkAgreements = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientFrameworkAgreementsData, ThrowOnError>,
): RequestResult<GetClientFrameworkAgreementsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientFrameworkAgreementsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientFrameworkAgreement',
		...options,
	});

export const patchClientFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<PatchClientFrameworkAgreementData, ThrowOnError>,
): RequestResult<PatchClientFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchClientFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createClientFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<CreateClientFrameworkAgreementData, ThrowOnError>,
): RequestResult<CreateClientFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateClientFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateClientFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateClientFrameworkAgreementData, ThrowOnError>,
): RequestResult<UpdateClientFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateClientFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientFrameworkAgreementDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetClientFrameworkAgreementDetailsData, ThrowOnError>,
): RequestResult<GetClientFrameworkAgreementDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetClientFrameworkAgreementDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientFrameworkAgreement/{id}',
		...options,
	});

export const getClientLegalEntitySettings = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientLegalEntitySettingsData, ThrowOnError>,
): RequestResult<GetClientLegalEntitySettingsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientLegalEntitySettingsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientLegalEntitySettings',
		...options,
	});

export const patchClientLegalEntitySettings = <ThrowOnError extends boolean = true>(
	options?: Options<PatchClientLegalEntitySettingsData, ThrowOnError>,
): RequestResult<PatchClientLegalEntitySettingsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchClientLegalEntitySettingsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientLegalEntitySettings',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createClientLegalEntitySettings = <ThrowOnError extends boolean = true>(
	options?: Options<CreateClientLegalEntitySettingsData, ThrowOnError>,
): RequestResult<CreateClientLegalEntitySettingsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateClientLegalEntitySettingsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ClientLegalEntitySettings',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getConsultants = <ThrowOnError extends boolean = true>(
	options?: Options<GetConsultantsData, ThrowOnError>,
): RequestResult<GetConsultantsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetConsultantsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Consultant',
		...options,
	});

export const createConsultant = <ThrowOnError extends boolean = true>(
	options?: Options<CreateConsultantData, ThrowOnError>,
): RequestResult<CreateConsultantResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateConsultantResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Consultant',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateConsultant = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateConsultantData, ThrowOnError>,
): RequestResult<UpdateConsultantResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateConsultantResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Consultant',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getConsultantDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetConsultantDetailsData, ThrowOnError>,
): RequestResult<GetConsultantDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetConsultantDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Consultant/{id}',
		...options,
	});

export const getConsultantAddresses = <ThrowOnError extends boolean = true>(
	options?: Options<GetConsultantAddressesData, ThrowOnError>,
): RequestResult<GetConsultantAddressesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetConsultantAddressesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantAddress',
		...options,
	});

export const createConsultantAddress = <ThrowOnError extends boolean = true>(
	options?: Options<CreateConsultantAddressData, ThrowOnError>,
): RequestResult<CreateConsultantAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateConsultantAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateConsultantAddress = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateConsultantAddressData, ThrowOnError>,
): RequestResult<UpdateConsultantAddressResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateConsultantAddressResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantAddress',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getConsultantAddressDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetConsultantAddressDetailsData, ThrowOnError>,
): RequestResult<GetConsultantAddressDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetConsultantAddressDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantAddress/{id}',
		...options,
	});

export const getConsultantFrameworkAgreements = <ThrowOnError extends boolean = true>(
	options?: Options<GetConsultantFrameworkAgreementsData, ThrowOnError>,
): RequestResult<GetConsultantFrameworkAgreementsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetConsultantFrameworkAgreementsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantFrameworkAgreement',
		...options,
	});

export const patchConsultantFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<PatchConsultantFrameworkAgreementData, ThrowOnError>,
): RequestResult<PatchConsultantFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchConsultantFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createConsultantFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<CreateConsultantFrameworkAgreementData, ThrowOnError>,
): RequestResult<CreateConsultantFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateConsultantFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateConsultantFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateConsultantFrameworkAgreementData, ThrowOnError>,
): RequestResult<UpdateConsultantFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateConsultantFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getConsultantFrameworkAgreementDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetConsultantFrameworkAgreementDetailsData, ThrowOnError>,
): RequestResult<GetConsultantFrameworkAgreementDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetConsultantFrameworkAgreementDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantFrameworkAgreement/{id}',
		...options,
	});

export const issueConsultantSessionToken = <ThrowOnError extends boolean = true>(
	options?: Options<IssueConsultantSessionTokenData, ThrowOnError>,
): RequestResult<IssueConsultantSessionTokenResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<IssueConsultantSessionTokenResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantsAndAgencyMembersAuth/issue-consultant-session-token',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const issueAgencyMemberSessionToken = <ThrowOnError extends boolean = true>(
	options?: Options<IssueAgencyMemberSessionTokenData, ThrowOnError>,
): RequestResult<IssueAgencyMemberSessionTokenResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<IssueAgencyMemberSessionTokenResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ConsultantsAndAgencyMembersAuth/issue-agency-member-session-token',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getDaysOff = <ThrowOnError extends boolean = true>(
	options?: Options<GetDaysOffData, ThrowOnError>,
): RequestResult<GetDaysOffResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetDaysOffResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DaysOff',
		...options,
	});

export const createDaysOff = <ThrowOnError extends boolean = true>(
	options?: Options<CreateDaysOffData, ThrowOnError>,
): RequestResult<CreateDaysOffResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateDaysOffResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DaysOff',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateDaysOff = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateDaysOffData, ThrowOnError>,
): RequestResult<UpdateDaysOffResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateDaysOffResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DaysOff',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const deleteDaysOff = <ThrowOnError extends boolean = true>(
	options: Options<DeleteDaysOffData, ThrowOnError>,
): RequestResult<DeleteDaysOffResponses, unknown, ThrowOnError> =>
	(options.client ?? client).delete<DeleteDaysOffResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DaysOff/{id}',
		...options,
	});

export const getDaysOffDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetDaysOffDetailsData, ThrowOnError>,
): RequestResult<GetDaysOffDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetDaysOffDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DaysOff/{id}',
		...options,
	});

export const getDocumentCaptureInvoices = <ThrowOnError extends boolean = true>(
	options?: Options<GetDocumentCaptureInvoicesData, ThrowOnError>,
): RequestResult<GetDocumentCaptureInvoicesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetDocumentCaptureInvoicesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DocumentCaptureInvoice',
		...options,
	});

export const getDocumentCaptureInvoice = <ThrowOnError extends boolean = true>(
	options: Options<GetDocumentCaptureInvoiceData, ThrowOnError>,
): RequestResult<GetDocumentCaptureInvoiceResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetDocumentCaptureInvoiceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DocumentCaptureInvoice/{documentNo}',
		...options,
	});

export const getDocumentCaptureInvoiceFile = <ThrowOnError extends boolean = true>(
	options: Options<GetDocumentCaptureInvoiceFileData, ThrowOnError>,
): RequestResult<GetDocumentCaptureInvoiceFileResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetDocumentCaptureInvoiceFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/DocumentCaptureInvoice/{documentNo}/files/{fileId}',
		...options,
	});

export const getEmployees = <ThrowOnError extends boolean = true>(
	options?: Options<GetEmployeesData, ThrowOnError>,
): RequestResult<GetEmployeesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetEmployeesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Employee',
		...options,
	});

export const getExpectedInvoiceGroups = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpectedInvoiceGroupsData, ThrowOnError>,
): RequestResult<GetExpectedInvoiceGroupsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetExpectedInvoiceGroupsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice-group',
		...options,
	});

export const getExpectedInvoiceGroupsForWorkflow = <ThrowOnError extends boolean = true>(
	options: Options<GetExpectedInvoiceGroupsForWorkflowData, ThrowOnError>,
): RequestResult<GetExpectedInvoiceGroupsForWorkflowResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetExpectedInvoiceGroupsForWorkflowResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice-group/for-workflow/{workflowId}',
		...options,
	});

export const getExpectedInvoices = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpectedInvoicesData, ThrowOnError>,
): RequestResult<GetExpectedInvoicesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetExpectedInvoicesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice',
		...options,
	});

export const getExpectedInvoiceDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetExpectedInvoiceDetailsData, ThrowOnError>,
): RequestResult<GetExpectedInvoiceDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetExpectedInvoiceDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice/{id}',
		...options,
	});

export const getExpectedInvoiceBillableLines = <ThrowOnError extends boolean = true>(
	options: Options<GetExpectedInvoiceBillableLinesData, ThrowOnError>,
): RequestResult<GetExpectedInvoiceBillableLinesResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetExpectedInvoiceBillableLinesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice/{id}/billable-lines',
		...options,
	});

export const getExpectedInvoicesForBillables = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpectedInvoicesForBillablesData, ThrowOnError>,
): RequestResult<GetExpectedInvoicesForBillablesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetExpectedInvoicesForBillablesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice/for-billables',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getExpectedInvoiceBillableAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpectedInvoiceBillableAllocationsData, ThrowOnError>,
): RequestResult<GetExpectedInvoiceBillableAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetExpectedInvoiceBillableAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice-billable-allocation',
		...options,
	});

export const createInvoiceDraftForExpectedInvoice = <ThrowOnError extends boolean = true>(
	options?: Options<CreateInvoiceDraftForExpectedInvoiceData, ThrowOnError>,
): RequestResult<CreateInvoiceDraftForExpectedInvoiceResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateInvoiceDraftForExpectedInvoiceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ExpectedInvoices/expected-invoice/create-invoice-draft',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientTasksAndExpenseActivities = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientTasksAndExpenseActivitiesData, ThrowOnError>,
): RequestResult<GetClientTasksAndExpenseActivitiesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetClientTasksAndExpenseActivitiesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/get-client-tasks-and-expense-activities',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getExpenses = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpensesData, ThrowOnError>,
): RequestResult<GetExpensesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetExpensesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense',
		...options,
	});

export const getExpenseDetails = <ThrowOnError extends boolean = true>(
	options?: Options<GetExpenseDetailsData, ThrowOnError>,
): RequestResult<GetExpenseDetailsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetExpenseDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/details',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getExpenseReceiptFile = <ThrowOnError extends boolean = true>(
	options: Options<GetExpenseReceiptFileData, ThrowOnError>,
): RequestResult<GetExpenseReceiptFileResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetExpenseReceiptFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/receipt-file/{expenseId}/{receiptFileId}',
		...options,
	});

export const calculateReimbursementAmount = <ThrowOnError extends boolean = true>(
	options?: Options<CalculateReimbursementAmountData, ThrowOnError>,
): RequestResult<CalculateReimbursementAmountResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<CalculateReimbursementAmountResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/calculate-reimbursement-amount',
		...options,
	});

export const saveExpenses = <ThrowOnError extends boolean = true>(
	options?: Options<SaveExpensesData, ThrowOnError>,
): RequestResult<SaveExpensesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SaveExpensesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/save',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const decideExpenseRfcs = <ThrowOnError extends boolean = true>(
	options?: Options<DecideExpenseRfcsData, ThrowOnError>,
): RequestResult<DecideExpenseRfcsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<DecideExpenseRfcsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Expense/decide-rfcs',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const postApiFileUploadTemp = <ThrowOnError extends boolean = true>(
	options?: Options<PostApiFileUploadTempData, ThrowOnError>,
): RequestResult<PostApiFileUploadTempResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<PostApiFileUploadTempResponses, unknown, ThrowOnError>({
		...formDataBodySerializer,
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/File/upload-temp',
		...options,
		headers: {
			'Content-Type': null,
			...options?.headers,
		},
	});

export const getCountries = <ThrowOnError extends boolean = true>(
	options?: Options<GetCountriesData, ThrowOnError>,
): RequestResult<GetCountriesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetCountriesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/GlobalReferenceData/countries',
		...options,
	});

export const getCurrencies = <ThrowOnError extends boolean = true>(
	options?: Options<GetCurrenciesData, ThrowOnError>,
): RequestResult<GetCurrenciesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetCurrenciesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/GlobalReferenceData/currencies',
		...options,
	});

export const getConvertibleCurrencies = <ThrowOnError extends boolean = true>(
	options?: Options<GetConvertibleCurrenciesData, ThrowOnError>,
): RequestResult<GetConvertibleCurrenciesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetConvertibleCurrenciesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/GlobalReferenceData/convertible-currencies',
		...options,
	});

export const getLanguages = <ThrowOnError extends boolean = true>(
	options?: Options<GetLanguagesData, ThrowOnError>,
): RequestResult<GetLanguagesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetLanguagesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/GlobalReferenceData/languages',
		...options,
	});

export const getIntercompanyFrameworkAgreements = <ThrowOnError extends boolean = true>(
	options?: Options<GetIntercompanyFrameworkAgreementsData, ThrowOnError>,
): RequestResult<GetIntercompanyFrameworkAgreementsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetIntercompanyFrameworkAgreementsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/IntercompanyFrameworkAgreement',
		...options,
	});

export const patchIntercompanyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<PatchIntercompanyFrameworkAgreementData, ThrowOnError>,
): RequestResult<PatchIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/IntercompanyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createIntercompanyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<CreateIntercompanyFrameworkAgreementData, ThrowOnError>,
): RequestResult<CreateIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/IntercompanyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateIntercompanyFrameworkAgreement = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateIntercompanyFrameworkAgreementData, ThrowOnError>,
): RequestResult<UpdateIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateIntercompanyFrameworkAgreementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/IntercompanyFrameworkAgreement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getIntercompanyFrameworkAgreementDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetIntercompanyFrameworkAgreementDetailsData, ThrowOnError>,
): RequestResult<GetIntercompanyFrameworkAgreementDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetIntercompanyFrameworkAgreementDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/IntercompanyFrameworkAgreement/{id}',
		...options,
	});

export const getInternalLegalEntities = <ThrowOnError extends boolean = true>(
	options?: Options<GetInternalLegalEntitiesData, ThrowOnError>,
): RequestResult<GetInternalLegalEntitiesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInternalLegalEntitiesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity',
		...options,
	});

export const updateInternalLegalEntity = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateInternalLegalEntityData, ThrowOnError>,
): RequestResult<UpdateInternalLegalEntityResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateInternalLegalEntityResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInternalLegalEntityDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetInternalLegalEntityDetailsData, ThrowOnError>,
): RequestResult<GetInternalLegalEntityDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInternalLegalEntityDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity/{id}',
		...options,
	});

export const getInternalLegalEntityInvoicingDefaults = <ThrowOnError extends boolean = true>(
	options: Options<GetInternalLegalEntityInvoicingDefaultsData, ThrowOnError>,
): RequestResult<GetInternalLegalEntityInvoicingDefaultsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInternalLegalEntityInvoicingDefaultsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity/{id}/invoicing-defaults',
		...options,
	});

export const getInternalLegalEntityAddresses = <ThrowOnError extends boolean = true>(
	options?: Options<GetInternalLegalEntityAddressesData, ThrowOnError>,
): RequestResult<GetInternalLegalEntityAddressesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInternalLegalEntityAddressesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity/addresses',
		...options,
	});

export const getInternalLegalEntityInvoiceSendingProfiles = <ThrowOnError extends boolean = true>(
	options?: Options<GetInternalLegalEntityInvoiceSendingProfilesData, ThrowOnError>,
): RequestResult<GetInternalLegalEntityInvoiceSendingProfilesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInternalLegalEntityInvoiceSendingProfilesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InternalLegalEntity/invoice-sending-profiles',
		...options,
	});

export const createInvoiceDraft = <ThrowOnError extends boolean = true>(
	options?: Options<CreateInvoiceDraftData, ThrowOnError>,
): RequestResult<CreateInvoiceDraftResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateInvoiceDraftResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/create-draft',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createFullCreditNote = <ThrowOnError extends boolean = true>(
	options?: Options<CreateFullCreditNoteData, ThrowOnError>,
): RequestResult<CreateFullCreditNoteResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateFullCreditNoteResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/create-full-credit-note',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoices = <ThrowOnError extends boolean = true>(
	options?: Options<GetInvoicesData, ThrowOnError>,
): RequestResult<GetInvoicesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInvoicesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice',
		...options,
	});

export const updateInvoice = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateInvoiceData, ThrowOnError>,
): RequestResult<UpdateInvoiceResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateInvoiceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const markAsReadyToSend = <ThrowOnError extends boolean = true>(
	options?: Options<MarkAsReadyToSendData, ThrowOnError>,
): RequestResult<MarkAsReadyToSendResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<MarkAsReadyToSendResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/mark-ready-to-send',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const markAsDraft = <ThrowOnError extends boolean = true>(
	options?: Options<MarkAsDraftData, ThrowOnError>,
): RequestResult<MarkAsDraftResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<MarkAsDraftResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/mark-draft',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const sendToBusinessCentral = <ThrowOnError extends boolean = true>(
	options?: Options<SendToBusinessCentralData, ThrowOnError>,
): RequestResult<SendToBusinessCentralResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SendToBusinessCentralResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/send-to-business-central',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const processBusinessCentralRejection = <ThrowOnError extends boolean = true>(
	options?: Options<ProcessBusinessCentralRejectionData, ThrowOnError>,
): RequestResult<ProcessBusinessCentralRejectionResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ProcessBusinessCentralRejectionResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/process-business-central-rejection',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const processBusinessCentralAcceptance = <ThrowOnError extends boolean = true>(
	options?: Options<ProcessBusinessCentralAcceptanceData, ThrowOnError>,
): RequestResult<ProcessBusinessCentralAcceptanceResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ProcessBusinessCentralAcceptanceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/process-business-central-acceptance',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const processBusinessCentralIssuance = <ThrowOnError extends boolean = true>(
	options?: Options<ProcessBusinessCentralIssuanceData, ThrowOnError>,
): RequestResult<ProcessBusinessCentralIssuanceResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ProcessBusinessCentralIssuanceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/process-business-central-issuance',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const pullInvoiceBusinessCentralStatus = <ThrowOnError extends boolean = true>(
	options?: Options<PullInvoiceBusinessCentralStatusData, ThrowOnError>,
): RequestResult<PullInvoiceBusinessCentralStatusResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<PullInvoiceBusinessCentralStatusResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/pull-invoice-business-central-status',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createSelfBillingNumberSequences = <ThrowOnError extends boolean = true>(
	options?: Options<CreateSelfBillingNumberSequencesData, ThrowOnError>,
): RequestResult<CreateSelfBillingNumberSequencesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateSelfBillingNumberSequencesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/create-self-billing-number-sequences',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoiceDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceDetailsData, ThrowOnError>,
): RequestResult<GetInvoiceDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}',
		...options,
	});

export const getInvoiceAttachmentFile = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceAttachmentFileData, ThrowOnError>,
): RequestResult<GetInvoiceAttachmentFileResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceAttachmentFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/attachment-file/{attachmentId}',
		...options,
	});

export const getInvoiceAutoRows = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceAutoRowsData, ThrowOnError>,
): RequestResult<GetInvoiceAutoRowsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceAutoRowsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/auto-rows',
		...options,
	});

export const getInvoiceTimesheet = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceTimesheetData, ThrowOnError>,
): RequestResult<GetInvoiceTimesheetResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceTimesheetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/timesheet',
		...options,
	});

export const getInvoiceTimesheetPdf = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceTimesheetPdfData, ThrowOnError>,
): RequestResult<GetInvoiceTimesheetPdfResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceTimesheetPdfResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/timesheet/pdf',
		...options,
	});

export const getInvoiceDetailsMismatch = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceDetailsMismatchData, ThrowOnError>,
): RequestResult<GetInvoiceDetailsMismatchResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceDetailsMismatchResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/mismatch-details',
		...options,
	});

export const getInvoiceReceipts = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceReceiptsData, ThrowOnError>,
): RequestResult<GetInvoiceReceiptsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceReceiptsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/{invoiceId}/receipts',
		...options,
	});

export const updateInvoiceAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateInvoiceAllocationsData, ThrowOnError>,
): RequestResult<UpdateInvoiceAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<UpdateInvoiceAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/update-allocations',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const relinkToExpectedInvoice = <ThrowOnError extends boolean = true>(
	options?: Options<RelinkToExpectedInvoiceData, ThrowOnError>,
): RequestResult<RelinkToExpectedInvoiceResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<RelinkToExpectedInvoiceResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Invoice/relink-to-expected-invoice',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoiceDatesRulesets = <ThrowOnError extends boolean = true>(
	options?: Options<GetInvoiceDatesRulesetsData, ThrowOnError>,
): RequestResult<GetInvoiceDatesRulesetsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInvoiceDatesRulesetsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceDatesRuleset',
		...options,
	});

export const createInvoiceDatesRuleset = <ThrowOnError extends boolean = true>(
	options?: Options<CreateInvoiceDatesRulesetData, ThrowOnError>,
): RequestResult<CreateInvoiceDatesRulesetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateInvoiceDatesRulesetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceDatesRuleset',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoiceDatesRulesetDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceDatesRulesetDetailsData, ThrowOnError>,
): RequestResult<GetInvoiceDatesRulesetDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceDatesRulesetDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceDatesRuleset/{invoiceDatesRulesetId}',
		...options,
	});

export const getInvoiceRowsLayouts = <ThrowOnError extends boolean = true>(
	options?: Options<GetInvoiceRowsLayoutsData, ThrowOnError>,
): RequestResult<GetInvoiceRowsLayoutsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInvoiceRowsLayoutsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceRowsLayout',
		...options,
	});

export const createInvoiceRowsLayout = <ThrowOnError extends boolean = true>(
	options?: Options<CreateInvoiceRowsLayoutData, ThrowOnError>,
): RequestResult<CreateInvoiceRowsLayoutResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateInvoiceRowsLayoutResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceRowsLayout',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateInvoiceRowsLayout = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateInvoiceRowsLayoutData, ThrowOnError>,
): RequestResult<UpdateInvoiceRowsLayoutResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateInvoiceRowsLayoutResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceRowsLayout',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoiceRowsLayoutDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoiceRowsLayoutDetailsData, ThrowOnError>,
): RequestResult<GetInvoiceRowsLayoutDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoiceRowsLayoutDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoiceRowsLayout/{id}',
		...options,
	});

export const getInvoicingScheduleCustomDatesList = <ThrowOnError extends boolean = true>(
	options?: Options<GetInvoicingScheduleCustomDatesListData, ThrowOnError>,
): RequestResult<GetInvoicingScheduleCustomDatesListResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetInvoicingScheduleCustomDatesListResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoicingScheduleCustomDates',
		...options,
	});

export const createInvoicingScheduleCustomDates = <ThrowOnError extends boolean = true>(
	options?: Options<CreateInvoicingScheduleCustomDatesData, ThrowOnError>,
): RequestResult<CreateInvoicingScheduleCustomDatesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateInvoicingScheduleCustomDatesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoicingScheduleCustomDates',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateInvoicingScheduleCustomDates = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateInvoicingScheduleCustomDatesData, ThrowOnError>,
): RequestResult<UpdateInvoicingScheduleCustomDatesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateInvoicingScheduleCustomDatesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoicingScheduleCustomDates',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getInvoicingScheduleCustomDatesDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetInvoicingScheduleCustomDatesDetailsData, ThrowOnError>,
): RequestResult<GetInvoicingScheduleCustomDatesDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetInvoicingScheduleCustomDatesDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/InvoicingScheduleCustomDates/{id}',
		...options,
	});

export const clearAllCaches = <ThrowOnError extends boolean = true>(
	options?: Options<ClearAllCachesData, ThrowOnError>,
): RequestResult<ClearAllCachesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ClearAllCachesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Maintenance/ClearAllCaches',
		...options,
	});

export const getMonetaryCapInstances = <ThrowOnError extends boolean = true>(
	options?: Options<GetMonetaryCapInstancesData, ThrowOnError>,
): RequestResult<GetMonetaryCapInstancesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetMonetaryCapInstancesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/MonetaryCapInstance',
		...options,
	});

export const getMonetaryCapInstanceAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<GetMonetaryCapInstanceAllocationsData, ThrowOnError>,
): RequestResult<GetMonetaryCapInstanceAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetMonetaryCapInstanceAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/MonetaryCapInstance/allocations',
		...options,
	});

export const getMonetaryCapInstanceDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetMonetaryCapInstanceDetailsData, ThrowOnError>,
): RequestResult<GetMonetaryCapInstanceDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetMonetaryCapInstanceDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/MonetaryCapInstance/{id}',
		...options,
	});

export const getPaymentTerms = <ThrowOnError extends boolean = true>(
	options?: Options<GetPaymentTermsData, ThrowOnError>,
): RequestResult<GetPaymentTermsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPaymentTermsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PaymentTerms',
		...options,
	});

export const updatePaymentTerms = <ThrowOnError extends boolean = true>(
	options?: Options<UpdatePaymentTermsData, ThrowOnError>,
): RequestResult<UpdatePaymentTermsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<UpdatePaymentTermsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PaymentTerms',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createPaymentTerms = <ThrowOnError extends boolean = true>(
	options?: Options<CreatePaymentTermsData, ThrowOnError>,
): RequestResult<CreatePaymentTermsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreatePaymentTermsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PaymentTerms',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getPaymentTermsDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetPaymentTermsDetailsData, ThrowOnError>,
): RequestResult<GetPaymentTermsDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetPaymentTermsDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PaymentTerms/{paymentTermsId}',
		...options,
	});

export const getProductionProviderReportingPeriods = <ThrowOnError extends boolean = true>(
	options?: Options<GetProductionProviderReportingPeriodsData, ThrowOnError>,
): RequestResult<GetProductionProviderReportingPeriodsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetProductionProviderReportingPeriodsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Production/provider-reporting-periods',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const confirmClientTaskProviderAssignmentReportingPeriodManualReview = <ThrowOnError extends boolean = true>(
	options?: Options<ConfirmClientTaskProviderAssignmentReportingPeriodManualReviewData, ThrowOnError>,
): RequestResult<ConfirmClientTaskProviderAssignmentReportingPeriodManualReviewResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<
		ConfirmClientTaskProviderAssignmentReportingPeriodManualReviewResponses,
		unknown,
		ThrowOnError
	>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Production/confirm-client-task-provider-assignment-reporting-period-manual-review',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const checkProductionChecklistItem = <ThrowOnError extends boolean = true>(
	options?: Options<CheckProductionChecklistItemData, ThrowOnError>,
): RequestResult<CheckProductionChecklistItemResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CheckProductionChecklistItemResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Production/check-production-checklist-item',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const uncheckProductionChecklistItem = <ThrowOnError extends boolean = true>(
	options?: Options<UncheckProductionChecklistItemData, ThrowOnError>,
): RequestResult<UncheckProductionChecklistItemResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<UncheckProductionChecklistItemResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Production/uncheck-production-checklist-item',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getProductionChecklistItems = <ThrowOnError extends boolean = true>(
	options?: Options<GetProductionChecklistItemsData, ThrowOnError>,
): RequestResult<GetProductionChecklistItemsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetProductionChecklistItemsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProductionChecklistItem',
		...options,
	});

export const createProductionChecklistItem = <ThrowOnError extends boolean = true>(
	options?: Options<CreateProductionChecklistItemData, ThrowOnError>,
): RequestResult<CreateProductionChecklistItemResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateProductionChecklistItemResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProductionChecklistItem',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getProviderReportingPeriods = <ThrowOnError extends boolean = true>(
	options?: Options<GetProviderReportingPeriodsData, ThrowOnError>,
): RequestResult<GetProviderReportingPeriodsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetProviderReportingPeriodsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProviderReportingPeriod',
		...options,
	});

export const getProviderReportingPeriodDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetProviderReportingPeriodDetailsData, ThrowOnError>,
): RequestResult<GetProviderReportingPeriodDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetProviderReportingPeriodDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProviderReportingPeriod/{id}',
		...options,
	});

export const closeClientTaskProviderAssignmentReportingPeriod = <ThrowOnError extends boolean = true>(
	options?: Options<CloseClientTaskProviderAssignmentReportingPeriodData, ThrowOnError>,
): RequestResult<CloseClientTaskProviderAssignmentReportingPeriodResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CloseClientTaskProviderAssignmentReportingPeriodResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProviderReportingPeriod/close-client-task-provider-assignment-reporting-period',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const confirmClientTaskProviderAssignmentReportingPeriodReview = <ThrowOnError extends boolean = true>(
	options?: Options<ConfirmClientTaskProviderAssignmentReportingPeriodReviewData, ThrowOnError>,
): RequestResult<ConfirmClientTaskProviderAssignmentReportingPeriodReviewResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<ConfirmClientTaskProviderAssignmentReportingPeriodReviewResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/ProviderReportingPeriod/confirm-client-task-provider-assignment-reporting-period-review',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getPurchaseOrders = <ThrowOnError extends boolean = true>(
	options?: Options<GetPurchaseOrdersData, ThrowOnError>,
): RequestResult<GetPurchaseOrdersResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPurchaseOrdersResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder',
		...options,
	});

export const patchPurchaseOrder = <ThrowOnError extends boolean = true>(
	options?: Options<PatchPurchaseOrderData, ThrowOnError>,
): RequestResult<PatchPurchaseOrderResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchPurchaseOrderResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createPurchaseOrder = <ThrowOnError extends boolean = true>(
	options?: Options<CreatePurchaseOrderData, ThrowOnError>,
): RequestResult<CreatePurchaseOrderResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreatePurchaseOrderResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const assignResponsiblesToPurchaseOrders = <ThrowOnError extends boolean = true>(
	options?: Options<AssignResponsiblesToPurchaseOrdersData, ThrowOnError>,
): RequestResult<AssignResponsiblesToPurchaseOrdersResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<AssignResponsiblesToPurchaseOrdersResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/assign-responsibles',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const setPurchaseOrderLimitsCompletion = <ThrowOnError extends boolean = true>(
	options?: Options<SetPurchaseOrderLimitsCompletionData, ThrowOnError>,
): RequestResult<SetPurchaseOrderLimitsCompletionResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SetPurchaseOrderLimitsCompletionResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/set-limits-completion',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getPurchaseOrderDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetPurchaseOrderDetailsData, ThrowOnError>,
): RequestResult<GetPurchaseOrderDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetPurchaseOrderDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/{id}',
		...options,
	});

export const getPurchaseOrderFile = <ThrowOnError extends boolean = true>(
	options: Options<GetPurchaseOrderFileData, ThrowOnError>,
): RequestResult<GetPurchaseOrderFileResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetPurchaseOrderFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/file/{purchaseOrderId}/{fileId}',
		...options,
	});

export const getPurchaseOrderResponsiblesDefaults = <ThrowOnError extends boolean = true>(
	options?: Options<GetPurchaseOrderResponsiblesDefaultsData, ThrowOnError>,
): RequestResult<GetPurchaseOrderResponsiblesDefaultsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPurchaseOrderResponsiblesDefaultsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/responsibles-defaults',
		...options,
	});

export const getPurchaseOrderEmployeeResponsibles = <ThrowOnError extends boolean = true>(
	options?: Options<GetPurchaseOrderEmployeeResponsiblesData, ThrowOnError>,
): RequestResult<GetPurchaseOrderEmployeeResponsiblesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPurchaseOrderEmployeeResponsiblesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/employee-responsibles',
		...options,
	});

export const getPurchaseOrderIssuerResponsibles = <ThrowOnError extends boolean = true>(
	options?: Options<GetPurchaseOrderIssuerResponsiblesData, ThrowOnError>,
): RequestResult<GetPurchaseOrderIssuerResponsiblesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPurchaseOrderIssuerResponsiblesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/issuer-responsibles',
		...options,
	});

export const getAllPurchaseOrderBillableAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<GetAllPurchaseOrderBillableAllocationsData, ThrowOnError>,
): RequestResult<GetAllPurchaseOrderBillableAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetAllPurchaseOrderBillableAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/billable-allocations',
		...options,
	});

export const updatePurchaseOrderLimitAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<UpdatePurchaseOrderLimitAllocationsData, ThrowOnError>,
): RequestResult<UpdatePurchaseOrderLimitAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<UpdatePurchaseOrderLimitAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/PurchaseOrder/update-limit-allocations',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getSagas = <ThrowOnError extends boolean = true>(
	options?: Options<GetSagasData, ThrowOnError>,
): RequestResult<GetSagasResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetSagasResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Saga',
		...options,
	});

export const getSagaDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetSagaDetailsData, ThrowOnError>,
): RequestResult<GetSagaDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetSagaDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Saga/{id}',
		...options,
	});

export const getSagaStepTimings = <ThrowOnError extends boolean = true>(
	options: Options<GetSagaStepTimingsData, ThrowOnError>,
): RequestResult<GetSagaStepTimingsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetSagaStepTimingsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Saga/{id}/step-timings',
		...options,
	});

export const scheduleContinueSaga = <ThrowOnError extends boolean = true>(
	options: Options<ScheduleContinueSagaData, ThrowOnError>,
): RequestResult<ScheduleContinueSagaResponses, unknown, ThrowOnError> =>
	(options.client ?? client).post<ScheduleContinueSagaResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Saga/{id}/schedule-continue',
		...options,
	});

export const getSchedules = <ThrowOnError extends boolean = true>(
	options?: Options<GetSchedulesData, ThrowOnError>,
): RequestResult<GetSchedulesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetSchedulesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Schedule',
		...options,
	});

export const createSchedule = <ThrowOnError extends boolean = true>(
	options?: Options<CreateScheduleData, ThrowOnError>,
): RequestResult<CreateScheduleResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateScheduleResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Schedule',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getSchedulePeriods = <ThrowOnError extends boolean = true>(
	options?: Options<GetSchedulePeriodsData, ThrowOnError>,
): RequestResult<GetSchedulePeriodsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetSchedulePeriodsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Schedule/period',
		...options,
	});

export const getScheduleDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetScheduleDetailsData, ThrowOnError>,
): RequestResult<GetScheduleDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetScheduleDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Schedule/{id}',
		...options,
	});

export const getProfessionalRoles = <ThrowOnError extends boolean = true>(
	options?: Options<GetProfessionalRolesData, ThrowOnError>,
): RequestResult<GetProfessionalRolesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetProfessionalRolesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/SourcingIntegration/professional-roles',
		...options,
	});

export const updateTeamsAndDivisionsNode = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateTeamsAndDivisionsNodeData, ThrowOnError>,
): RequestResult<UpdateTeamsAndDivisionsNodeResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateTeamsAndDivisionsNodeResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TeamsAndDivisionsNode',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getTeamsAndDivisionsTree = <ThrowOnError extends boolean = true>(
	options: Options<GetTeamsAndDivisionsTreeData, ThrowOnError>,
): RequestResult<GetTeamsAndDivisionsTreeResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetTeamsAndDivisionsTreeResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TeamsAndDivisionsNode/{id}',
		...options,
	});

export const getTenants = <ThrowOnError extends boolean = true>(
	options?: Options<GetTenantsData, ThrowOnError>,
): RequestResult<GetTenantsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetTenantsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Tenant',
		...options,
	});

export const updateTenant = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateTenantData, ThrowOnError>,
): RequestResult<UpdateTenantResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateTenantResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Tenant',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getTenantDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetTenantDetailsData, ThrowOnError>,
): RequestResult<GetTenantDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetTenantDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Tenant/{id}',
		...options,
	});

export const saveTimesheetDailyReportDrafts = <ThrowOnError extends boolean = true>(
	options?: Options<SaveTimesheetDailyReportDraftsData, ThrowOnError>,
): RequestResult<SaveTimesheetDailyReportDraftsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SaveTimesheetDailyReportDraftsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport/save-drafts',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const submitTimesheetDailyReports = <ThrowOnError extends boolean = true>(
	options?: Options<SubmitTimesheetDailyReportsData, ThrowOnError>,
): RequestResult<SubmitTimesheetDailyReportsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SubmitTimesheetDailyReportsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport/submit',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const saveTimesheetDailyReportRfcs = <ThrowOnError extends boolean = true>(
	options?: Options<SaveTimesheetDailyReportRfcsData, ThrowOnError>,
): RequestResult<SaveTimesheetDailyReportRfcsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SaveTimesheetDailyReportRfcsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport/save-rfcs',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const decideTimesheetDailyReportRfcs = <ThrowOnError extends boolean = true>(
	options?: Options<DecideTimesheetDailyReportRfcsData, ThrowOnError>,
): RequestResult<DecideTimesheetDailyReportRfcsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<DecideTimesheetDailyReportRfcsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport/decide-rfcs',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getTimesheetDailyReports = <ThrowOnError extends boolean = true>(
	options?: Options<GetTimesheetDailyReportsData, ThrowOnError>,
): RequestResult<GetTimesheetDailyReportsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetTimesheetDailyReportsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport',
		...options,
	});

export const getTimesheetDailyReportsDetails = <ThrowOnError extends boolean = true>(
	options?: Options<GetTimesheetDailyReportsDetailsData, ThrowOnError>,
): RequestResult<GetTimesheetDailyReportsDetailsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetTimesheetDailyReportsDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/TimesheetDailyReport/details',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getUnitBatches = <ThrowOnError extends boolean = true>(
	options?: Options<GetUnitBatchesData, ThrowOnError>,
): RequestResult<GetUnitBatchesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUnitBatchesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitBatch',
		...options,
	});

export const getUnitCapInstances = <ThrowOnError extends boolean = true>(
	options?: Options<GetUnitCapInstancesData, ThrowOnError>,
): RequestResult<GetUnitCapInstancesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUnitCapInstancesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitCapInstance',
		...options,
	});

export const getUnitCapInstanceAllocations = <ThrowOnError extends boolean = true>(
	options?: Options<GetUnitCapInstanceAllocationsData, ThrowOnError>,
): RequestResult<GetUnitCapInstanceAllocationsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUnitCapInstanceAllocationsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitCapInstance/allocations',
		...options,
	});

export const getUnitCapInstanceDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetUnitCapInstanceDetailsData, ThrowOnError>,
): RequestResult<GetUnitCapInstanceDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetUnitCapInstanceDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitCapInstance/{id}',
		...options,
	});

export const getUnitsOfMeasurement = <ThrowOnError extends boolean = true>(
	options?: Options<GetUnitsOfMeasurementData, ThrowOnError>,
): RequestResult<GetUnitsOfMeasurementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUnitsOfMeasurementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurement',
		...options,
	});

export const createUnitOfMeasurement = <ThrowOnError extends boolean = true>(
	options?: Options<CreateUnitOfMeasurementData, ThrowOnError>,
): RequestResult<CreateUnitOfMeasurementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateUnitOfMeasurementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateUnitOfMeasurement = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateUnitOfMeasurementData, ThrowOnError>,
): RequestResult<UpdateUnitOfMeasurementResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateUnitOfMeasurementResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurement',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getUnitOfMeasurementDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetUnitOfMeasurementDetailsData, ThrowOnError>,
): RequestResult<GetUnitOfMeasurementDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetUnitOfMeasurementDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurement/{id}',
		...options,
	});

export const getUnitOfMeasurementConversionTables = <ThrowOnError extends boolean = true>(
	options?: Options<GetUnitOfMeasurementConversionTablesData, ThrowOnError>,
): RequestResult<GetUnitOfMeasurementConversionTablesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUnitOfMeasurementConversionTablesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurementConversionTable',
		...options,
	});

export const patchUnitOfMeasurementConversionTable = <ThrowOnError extends boolean = true>(
	options?: Options<PatchUnitOfMeasurementConversionTableData, ThrowOnError>,
): RequestResult<PatchUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurementConversionTable',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createUnitOfMeasurementConversionTable = <ThrowOnError extends boolean = true>(
	options?: Options<CreateUnitOfMeasurementConversionTableData, ThrowOnError>,
): RequestResult<CreateUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurementConversionTable',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateUnitOfMeasurementConversionTable = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateUnitOfMeasurementConversionTableData, ThrowOnError>,
): RequestResult<UpdateUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateUnitOfMeasurementConversionTableResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurementConversionTable',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getUnitOfMeasurementConversionTableDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetUnitOfMeasurementConversionTableDetailsData, ThrowOnError>,
): RequestResult<GetUnitOfMeasurementConversionTableDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetUnitOfMeasurementConversionTableDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UnitOfMeasurementConversionTable/{id}',
		...options,
	});

export const getUserManagementPermissionsModel = <ThrowOnError extends boolean = true>(
	options?: Options<GetUserManagementPermissionsModelData, ThrowOnError>,
): RequestResult<GetUserManagementPermissionsModelResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetUserManagementPermissionsModelResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UserManagement/Permissions',
		...options,
	});

export const synchronizeUserManagementData = <ThrowOnError extends boolean = true>(
	options?: Options<SynchronizeUserManagementDataData, ThrowOnError>,
): RequestResult<SynchronizeUserManagementDataResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<SynchronizeUserManagementDataResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/UserManagement/SynchronizeData',
		...options,
	});

export const getVatCodes = <ThrowOnError extends boolean = true>(
	options?: Options<GetVatCodesData, ThrowOnError>,
): RequestResult<GetVatCodesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetVatCodesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/VatCode',
		...options,
	});

export const createVatCode = <ThrowOnError extends boolean = true>(
	options?: Options<CreateVatCodeData, ThrowOnError>,
): RequestResult<CreateVatCodeResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateVatCodeResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/VatCode',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getVatCodeDetailsModel = <ThrowOnError extends boolean = true>(
	options: Options<GetVatCodeDetailsModelData, ThrowOnError>,
): RequestResult<GetVatCodeDetailsModelResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetVatCodeDetailsModelResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/VatCode/{vatCodeId}',
		...options,
	});

export const getWorkflows = <ThrowOnError extends boolean = true>(
	options?: Options<GetWorkflowsData, ThrowOnError>,
): RequestResult<GetWorkflowsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetWorkflowsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow',
		...options,
	});

export const createWorkflow = <ThrowOnError extends boolean = true>(
	options?: Options<CreateWorkflowData, ThrowOnError>,
): RequestResult<CreateWorkflowResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateWorkflowResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const applyWorkflowDraft = <ThrowOnError extends boolean = true>(
	options?: Options<ApplyWorkflowDraftData, ThrowOnError>,
): RequestResult<ApplyWorkflowDraftResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<ApplyWorkflowDraftResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const deleteWorkflow = <ThrowOnError extends boolean = true>(
	options: Options<DeleteWorkflowData, ThrowOnError>,
): RequestResult<DeleteWorkflowResponses, unknown, ThrowOnError> =>
	(options.client ?? client).delete<DeleteWorkflowResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/{id}',
		...options,
	});

export const getWorkflowDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/{id}',
		...options,
	});

export const getWorkflowsV2 = <ThrowOnError extends boolean = true>(
	options?: Options<GetWorkflowsV2Data, ThrowOnError>,
): RequestResult<GetWorkflowsV2Responses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetWorkflowsV2Responses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/v2',
		...options,
	});

export const getWorkflowInputDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowInputDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowInputDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowInputDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/{id}/input',
		...options,
	});

export const getWorkflowChangeset = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowChangesetData, ThrowOnError>,
): RequestResult<GetWorkflowChangesetResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowChangesetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/{id}/changeset',
		...options,
	});

export const getWorkflowSourcingRequestDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowSourcingRequestDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowSourcingRequestDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowSourcingRequestDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/Workflow/sourcing-request/{requestId}',
		...options,
	});

export const getWorkflowCapDefinitionAllocationSetDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowCapDefinitionAllocationSetDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowCapDefinitionAllocationSetDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowCapDefinitionAllocationSetDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowCapDefinitionAllocationSet/{workflowId}',
		...options,
	});

export const getWorkflowDrafts = <ThrowOnError extends boolean = true>(
	options?: Options<GetWorkflowDraftsData, ThrowOnError>,
): RequestResult<GetWorkflowDraftsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetWorkflowDraftsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowDraft',
		...options,
	});

export const patchWorkflowDraft = <ThrowOnError extends boolean = true>(
	options?: Options<PatchWorkflowDraftData, ThrowOnError>,
): RequestResult<PatchWorkflowDraftResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).patch<PatchWorkflowDraftResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowDraft',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const createWorkflowDraft = <ThrowOnError extends boolean = true>(
	options?: Options<CreateWorkflowDraftData, ThrowOnError>,
): RequestResult<CreateWorkflowDraftResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateWorkflowDraftResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowDraft',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getWorkflowDraftDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowDraftDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowDraftDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowDraftDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowDraft/{id}',
		...options,
	});

export const getWorkflowDraftChangeset = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowDraftChangesetData, ThrowOnError>,
): RequestResult<GetWorkflowDraftChangesetResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowDraftChangesetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowDraft/{id}/changeset',
		...options,
	});

export const getWorkflowExpectedInvoiceGroupDistributionDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowExpectedInvoiceGroupDistributionDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowExpectedInvoiceGroupDistributionDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowExpectedInvoiceGroupDistributionDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowExpectedInvoiceGroupDistribution/{workflowId}',
		...options,
	});

export const getWorkflowPurchaseOrderLimitAllocationSetDetails = <ThrowOnError extends boolean = true>(
	options: Options<GetWorkflowPurchaseOrderLimitAllocationSetDetailsData, ThrowOnError>,
): RequestResult<GetWorkflowPurchaseOrderLimitAllocationSetDetailsResponses, unknown, ThrowOnError> =>
	(options.client ?? client).get<GetWorkflowPurchaseOrderLimitAllocationSetDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowPurchaseOrderLimitAllocationSet/{workflowId}',
		...options,
	});

export const getSkiDiscountHistoricalValues = <ThrowOnError extends boolean = true>(
	options?: Options<GetSkiDiscountHistoricalValuesData, ThrowOnError>,
): RequestResult<GetSkiDiscountHistoricalValuesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetSkiDiscountHistoricalValuesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkflowsCommon/ski-discount-historical-values',
		...options,
	});

export const createProviderCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<CreateProviderCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<CreateProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<CreateProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/create-cap-instance-sign-off-set',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const updateProviderCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<UpdateProviderCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<UpdateProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).put<UpdateProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/update-cap-instance-sign-off-set',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const deleteProviderCapInstanceSignOffSet = <ThrowOnError extends boolean = true>(
	options?: Options<DeleteProviderCapInstanceSignOffSetData, ThrowOnError>,
): RequestResult<DeleteProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).delete<DeleteProviderCapInstanceSignOffSetResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/delete-cap-instance-sign-off-set',
		...options,
	});

export const getActiveCapDefinitions = <ThrowOnError extends boolean = true>(
	options?: Options<GetActiveCapDefinitionsData, ThrowOnError>,
): RequestResult<GetActiveCapDefinitionsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetActiveCapDefinitionsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-active-cap-definitions',
		...options,
	});

export const getBreachedCapInstances = <ThrowOnError extends boolean = true>(
	options?: Options<GetBreachedCapInstancesData, ThrowOnError>,
): RequestResult<GetBreachedCapInstancesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetBreachedCapInstancesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-breached-cap-instances',
		...options,
	});

export const getPendingCapInstanceSignOffSets = <ThrowOnError extends boolean = true>(
	options?: Options<GetPendingCapInstanceSignOffSetsData, ThrowOnError>,
): RequestResult<GetPendingCapInstanceSignOffSetsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetPendingCapInstanceSignOffSetsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-pending-cap-instance-sign-off-sets',
		...options,
	});

export const getResolvedCapInstanceSignOffSets = <ThrowOnError extends boolean = true>(
	options?: Options<GetResolvedCapInstanceSignOffSetsData, ThrowOnError>,
): RequestResult<GetResolvedCapInstanceSignOffSetsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetResolvedCapInstanceSignOffSetsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-resolved-cap-instance-sign-off-sets',
		...options,
	});

export const getProviderCapInstanceSignOffSetFile = <ThrowOnError extends boolean = true>(
	options?: Options<GetProviderCapInstanceSignOffSetFileData, ThrowOnError>,
): RequestResult<GetProviderCapInstanceSignOffSetFileResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetProviderCapInstanceSignOffSetFileResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-cap-instance-sign-off-set-file',
		...options,
	});

export const getCapInstanceSignOffSetsDetails = <ThrowOnError extends boolean = true>(
	options?: Options<GetCapInstanceSignOffSetsDetailsData, ThrowOnError>,
): RequestResult<GetCapInstanceSignOffSetsDetailsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetCapInstanceSignOffSetsDetailsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCap/get-cap-instance-sign-off-sets-details',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getClientsAndDates = <ThrowOnError extends boolean = true>(
	options?: Options<GetClientsAndDatesData, ThrowOnError>,
): RequestResult<GetClientsAndDatesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetClientsAndDatesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCommon/get-clients-and-dates',
		...options,
	});

export const getTimesheetDailyForms = <ThrowOnError extends boolean = true>(
	options?: Options<GetTimesheetDailyFormsData, ThrowOnError>,
): RequestResult<GetTimesheetDailyFormsResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).post<GetTimesheetDailyFormsResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCommon/get-daily-forms',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options?.headers,
		},
	});

export const getResponsibles = <ThrowOnError extends boolean = true>(
	options?: Options<GetResponsiblesData, ThrowOnError>,
): RequestResult<GetResponsiblesResponses, unknown, ThrowOnError> =>
	(options?.client ?? client).get<GetResponsiblesResponses, unknown, ThrowOnError>({
		security: [{ scheme: 'bearer', type: 'http' }],
		url: '/api/WorkTrackingCommon/get-responsibles',
		...options,
	});
